<template>
  <div>
    <b-modal
      id="careerModal"
      size="sm"
      hide-header
      hide-footer
      content-class="custom-modal-content"
      ref="baseModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <div
        class="d-flex flex-column align-items-center justify-content-center h-100"
      >
        <p class="modal-title text-center mb-4" v-html="modalText"></p>
        <button
          :style="{
            backgroundColor: '#FF0000',
            borderRadius: '2px',
            color: '#fff',
            border: 'none',
            padding: '10px',
          }"
          class="btn custom-btn"
          @click="$emit('button-click')"
        >
          {{ buttonText }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "BaseModal",
  props: {
    modalId: {
      type: String,
      required: true,
    },
    modalText: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
  },
  methods: {
    show() {
      this.$refs.baseModal.show();
    },
    hide() {
      this.$refs.baseModal.hide();
    },
  },
  mounted() {
    this.$bvModal.show("careerModal");
  },
};
</script>

<style scoped>
.custom-btn {
  margin-top: 45px;
  width: 208px;
  height: 45px;
  font-weight: bold;
  font-size: 16px;
}
>>> .custom-modal-content {
  height: 330px !important;
  width: 357px !important;
  margin: auto;
}

>>> .modal-content {
  height: 100%;
}

>>> .modal-body {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.modal-title {
  font-size: 16px;
  line-height: 2;
  font-weight: bold;
}
</style>
